// export const GLIST_WIDTH_AUTO: string   = 'auto'    // used when we need 100% width
export const GLIST_WIDTH_FIXED: string  = 'fixed'   // fixed width based on columns


export enum GlistWidthMode {
    AUTO    = 'auto',   // used when we need 100% width
    FIXED   = 'fixed'   // fixed width based on columns
}
